import type { Lang } from './i18n/types';
import { UNITE_GO_PATH_EN, UNITE_GO_PATH_ZH } from './pages/unite-go';
import { UNITE_BASE_PATH_EN, UNITE_BASE_PATH_ZH } from './pages/unite-base';

export type AppPage = 'home' | 'unite-base' | 'unite-go' | 'blog-list' | 'blog-post';

export type AppRoute = {
  page: AppPage;
  forcedLang?: Lang;
  blogId?: number;
};

export function blogListPath(lang: Lang): string {
  return lang === 'zh' ? '/zh/blog' : '/blog';
}

export function blogPostPath(lang: Lang, id: number): string {
  return `${blogListPath(lang)}/${id}`;
}

export function homePath(lang: Lang): string {
  return lang === 'zh' ? '/?lang=zh' : '/';
}

export function resolveRoute(pathname: string): AppRoute {
  const clean = pathname.replace(/\/+$/, '') || '/';

  if (clean === UNITE_BASE_PATH_EN) {
    return { page: 'unite-base', forcedLang: 'en' };
  }
  if (clean === UNITE_BASE_PATH_ZH) {
    return { page: 'unite-base', forcedLang: 'zh' };
  }

  if (clean === UNITE_GO_PATH_EN) return { page: 'unite-go', forcedLang: 'en' };
  if (clean === UNITE_GO_PATH_ZH) return { page: 'unite-go', forcedLang: 'zh' };

  const zhPost = /^\/zh\/blog\/(\d+)$/.exec(clean);
  if (zhPost) return { page: 'blog-post', forcedLang: 'zh', blogId: Number(zhPost[1]) };

  if (clean === '/zh/blog') return { page: 'blog-list', forcedLang: 'zh' };

  const enPost = /^\/blog\/(\d+)$/.exec(clean);
  if (enPost) return { page: 'blog-post', forcedLang: 'en', blogId: Number(enPost[1]) };

  if (clean === '/blog') return { page: 'blog-list', forcedLang: 'en' };

  return { page: 'home' };
}

export function getRoute(): AppRoute {
  if (typeof location === 'undefined') return { page: 'home' };
  return resolveRoute(location.pathname);
}
